export default "__VITE_ASSET__BcylU9Ox__"